import {
  Holder,
  Content,
  LeftSection,
  TitleHolder,
  TipHolder,
  ContactHolder,
  Footer,
  Logo,
  RightSection,
  ContactTitle,
  ContactValue,
  ContactList,
  AboutLink,
  BackButton,
  BackIcon
} from "./Future.style"
import SplitText from "../../../components/SplitText"
import Arrows from "../../../components/Icons/navy_double_arrow_left.svg"
import { AboutPath } from "../../../routes"
import LogoIcon from "./logo.svg"
import MapImg from "./map.jpg"

const pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}

const pageTransition = {
  ease: "easeIn",
  duration: 0.7
}

function Future() {
  return (
    <Holder
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <Content>
        <LeftSection>
          <TitleHolder>
            <SplitText
              initial="hidden"
              animate="visible"
              variants={{
                visible: i => ({
                  y: 0,
                  transition: {
                    ease: [0.455, 0.03, 0.515, 0.955],
                    duration: 1.65,
                    delay: i * 0.2
                  }
                }),
                hidden: { y: "100%" }
              }}
            >
              Come and
            </SplitText>
            <SplitText
              initial="hidden"
              animate="visible"
              variants={{
                visible: i => ({
                  y: 0,
                  transition: {
                    ease: [0.455, 0.03, 0.515, 0.955],
                    duration: 1.65,
                    delay: i * 0.2
                  }
                }),
                hidden: { y: "100%" }
              }}
            >
              say hi.
            </SplitText>
          </TitleHolder>
          <TipHolder>
            <span>
              Our London Sales Suite is open with viewings taking place on an appointment-only
              basis. To book a tour and for all futher enquiries, please contact us on:
            </span>
          </TipHolder>
          <ContactHolder>
            <ContactList>
              <ContactTitle>Get in Touch:</ContactTitle>
              <ContactValue>
                <a
                  target="_blank"
                  href="mailto:postmark@taylorwimpey.com"
                  rel="noopener noreferrer"
                >
                  postmark@taylorwimpey.com
                </a>
              </ContactValue>
              <ContactValue>+44 (0) 20 8003 3947</ContactValue>
            </ContactList>
            <ContactList>
              <ContactTitle>Sales Suite Address:</ContactTitle>
              <ContactValue>Postmark Marketing Suite,</ContactValue>
              <ContactValue>12 Mount Pleasant,</ContactValue>
              <ContactValue>WC1X 0BU</ContactValue>
            </ContactList>
            <ContactList>
              <ContactTitle>Sales Suite Opening Hours:</ContactTitle>
              <ContactValue>Mon CLOSED</ContactValue>
              <ContactValue>Tue 10:00 - 18:00</ContactValue>
              <ContactValue>Wed 10:00 - 18:00</ContactValue>
              <ContactValue>Thu 10:00 - 18:00</ContactValue>
              <ContactValue>Fri 10:00 - 18:00</ContactValue>
              <ContactValue>Sat 10:00 - 16:00</ContactValue>
              <ContactValue>Sun CLOSED</ContactValue>
            </ContactList>
          </ContactHolder>
        </LeftSection>
        <RightSection img={MapImg}></RightSection>
      </Content>
      <Footer>
        <AboutLink to={AboutPath}>
          <BackButton>
            <BackIcon src={Arrows} />
          </BackButton>
        </AboutLink>
        <Logo src={LogoIcon} />
      </Footer>
    </Holder>
  )
}

export default Future
